import { Handle, Position } from "reactflow"
import Icon from 'src/@core/components/icon'
import { CustomNodeProperties } from "../types/types"
import { Box, Typography } from "@mui/material" // Usamos Typography para mejor control

import '../styles/nodo-accion-por-valor.styles.css'

const NodoAccionPorValor = (props: CustomNodeProperties) => {
  return (
    <>
      <Handle
        type='target'
        id='in'
        position={Position.Left}
      />
      
      <Typography
        variant="caption"
        sx={{
          position: 'absolute',
          top: -20,
          left: '50%',
          transform: 'translateX(-50%)',
          whiteSpace: 'nowrap',
          fontWeight: 'bold',
          color: 'primary.main',
          fontSize: '0.5rem',
          textTransform: 'capitalize'
        }}
      >
        {props.data.label}
      </Typography>

      <div className="nodo-valor">
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          height="100%"
        >
          <Icon
            height={'100%'}
            icon={'humbleicons:arrow-split'} 
          />
        </Box>
      </div>

      {
        [...Array(props.data.n_salidas)].map((_, i) => {
          return (
            <Handle
              key={i}
              type='source'
              id={i.toString()}
              position={Position.Right}
              style={{ top: `${(i + 1) * 100 / (props.data.n_salidas + 1)}%` }}
            />
          )
        })
      }
    </>
  )
}

export default NodoAccionPorValor
